/**
 * @owner @Appboy/in-app-messages
 */

import { z } from "zod";
import { common } from "../common";

export const landingPageSurveySubmittedTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::LandingPageSurveySubmitted"),
  external_id: common.uuid.nullable(),
  name: z.string().nullable(),
});
